import { Component, OnInit, Input } from '@angular/core';
import { FormGroupFilters } from '../../table-filters/model/table-filter.model';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-input-date',
    templateUrl: './input-date.component.html',
    styleUrls: ['./input-date.component.scss'],
    imports: [ReactiveFormsModule, NgbInputDatepicker]
})
export class InputDateComponent implements OnInit {
  @Input() filter: FormGroupFilters;
  @Input() form: UntypedFormGroup;
  d2: any;

  constructor() { }

  ngOnInit() {

  }

}
